//----------------------------------
// Private Variables
//----------------------------------
const cache = {
  scrollbarWidth: null,
  supportScrollbarCSS: null,
};

export default class DomUtil {
  //---------------------------------------------------
  //
  //  Public Properties
  //
  //---------------------------------------------------
  static get supportsScrollbarCSS() {
    if (cache.supportScrollbarCSS === null) {
      const div = document.createElement('div');
      div.id = 'sbtest';
      div.style.overflow = 'scroll';
      div.style.width = '40px';
      div.style.visibility = 'hidden';
      div.innerHTML = '<style>#sbtest::-webkit-scrollbar {width:30px;}</style>';
      document.body.appendChild(div);
      cache.supportScrollbarCSS = div.scrollWidth === 10;
      document.body.removeChild(div);
    }
    return cache.supportScrollbarCSS;
  }

  static get defaultScrollbarWidth() {
    if (cache.scrollbarWidth === null) {
      const inner = document.createElement('p');
      inner.style.width = '100%';
      inner.style.height = '200px';

      const outer = document.createElement('div');
      outer.style.position = 'absolute';
      outer.style.top = '0px';
      outer.style.left = '0px';
      outer.style.visibility = 'hidden';
      outer.style.width = '200px';
      outer.style.height = '150px';
      outer.style.overflow = 'hidden';
      outer.appendChild(inner);

      document.body.appendChild(outer);
      const w1 = inner.offsetWidth;
      outer.style.overflow = 'scroll';
      let w2 = inner.offsetWidth;
      if (w1 === w2) w2 = outer.clientWidth;
      document.body.removeChild(outer);
      cache.scrollbarWidth = w1 - w2;
    }
    return cache.scrollbarWidth;
  }

  static get screenDPI() {
    const el = document.createElement('div');
    el.style.width = '1in';
    document.body.appendChild(el);

    const dpi = el.offsetWidth;
    document.body.removeChild(el);
    return dpi;
  }
}
